import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useState } from "react";
import stylesContacts from '../Contacts/Contacts.module.scss';
import { useAppSelector } from "../../hooks/hook";
import Avatar from "../Avatar/Avatar";
import DialogComponent from "../Settings/DialogComponent";
import { profileAPI } from "../../API/api";
import DescriptionComponent from "../Settings/DescriptionComponent";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import ShareChatButton from "./ShareChatButton";
const UserFullInfoComponent = () => {
    var _a;
    const user = useAppSelector(state => state.app.selectedChat);
    const onlineStatus = useAppSelector(state => state.app.onlineStatusSelectedUser);
    const [userInfo, setUserInfo] = useState(user);
    const [zoomAvatar, setZoomAvatar] = useState(false);
    const { t } = useTypedTranslation();
    const description = [
        { title: t('name'), description: userInfo.displayName },
        { title: 'email', description: userInfo.email },
        { title: t("dateOfRegistration"), description: (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.registrationDate) === null || _a === void 0 ? void 0 : _a.toString() }
    ];
    useLayoutEffect(() => {
        profileAPI.getCurrentInfo(user.uid)
            .then(data => setUserInfo(data));
    }, []);
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }, children: [_jsx("div", { style: { margin: '0 auto' }, children: _jsx("div", { onClick: () => setZoomAvatar(true), style: { cursor: 'pointer' }, children: _jsx(Avatar, { name: user.displayName, url: user === null || user === void 0 ? void 0 : user.photoURL, isOnline: onlineStatus.isOnline }) }) }), _jsx("div", { className: stylesContacts.item, children: _jsx(DescriptionComponent, { items: description }) }), _jsx("div", { className: stylesContacts.item, children: _jsx(ShareChatButton, { chat: user }) }), zoomAvatar &&
                _jsx(DialogComponent, { isOpen: zoomAvatar, onClose: setZoomAvatar, children: _jsx(Avatar, { name: userInfo.displayName, url: userInfo === null || userInfo === void 0 ? void 0 : userInfo.photoURL, zoom: true }) })] }));
};
export default UserFullInfoComponent;
